import React, { Component } from 'react'
import { connect } from 'react-redux'

import TextField from 'material-ui/TextField'
import MenuItem from 'material-ui/MenuItem';

import Select from 'components/Select'
import PaymentMethodIcon from './PaymentMethodIcon'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from 'selectors/common'
import { transactionEx } from 'selectors/transactions'

let select = dirtyRead(
	(state, props) => ({
		transaction: transactionEx(state, props.transactionID)
	})
)

const paymentMethods = [
	{value:"QuickBooks", primaryText:"Bank transaction"}
  , {value:"Card", primaryText:"Credit/ATM card"}
  , {value:"Paper check", primaryText:"Paper check"}
  , {value:"Paypal", primaryText:"Paypal"}
]

export class StatusSelect extends Component{
	render(){
		let { props } = this
		return(
			<Select
				key={props.transaction.paymentMethod}
				hintText="Select payment method"
				title="Please choose payment method for transaction"
				value={!props.transaction.paymentMethod && props.transaction.qbid ? "QuickBooks" : props.transaction.paymentMethod}
				icon= {
					(props.transaction.paymentMethod || props.transaction.qbid)? <PaymentMethodIcon id={props.transactionID} />
					:<i
						className="material-icons"
						style={{
							float: "left"
							, width: "26px"
							, position: "relative"
							, top: "0px"
							, left: "-3px"
							, color: "orange"
						}}
					>
						arrow_forward
					</i>
				}
				disabled={props.transaction.qbid || props.transaction.qbidNew}
				onChange={(evt, indx, value) =>{
					if (!props.transaction.qbid) props.STAGE({
						_id: props.transactionID
						, paymentMethod: value
						, refNo: (value == "QuickBooks") ? "" : "PAID by " + value, dueDate:new Date()
					})
				}}
			>
				{paymentMethods.map(method=> <MenuItem key={method.value} value={method.value} primaryText={method.primaryText} /> )}
			</Select>
		)
	}
}

export default connect(select, dataActions)(StatusSelect)



// WEBPACK FOOTER //
// ./src/routes/manager/transactionForm/PaymentMethodSelect.js